import { css } from 'linaria';
import { styled } from 'linaria/react';
import { ElementType } from 'react';

export const topLineSeeMoreStyles = css`
  position: relative;
  top: -4px;
  white-space: nowrap;
`;
export const topLineItemStyles = css`
  @media (--from-tablet) {
    &:not(&:last-of-type) {
      margin-right: var(--space-250);
    }
  }
`;
export const controlStyles = css`
  box-shadow: var(--box-shadow-m);
`;
export const sponsoredSeeMoreCardStylesMedia = css`
  @media (--to-tablet) {
    box-sizing: content-box;
    width: 139px !important;
    height: 272px !important;
    padding: 16px;
  }
`;
export const SeeMoreCardStyles: ElementType = styled.a<{ isSponsored: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: var(--space-450);
  text-decoration: none;
  width: ${({ isSponsored }) => (isSponsored ? '192px' : '100%')};
  height: 100%;
  background-color: ${({ isSponsored }) => (isSponsored ? 'var(--background-primary)' : 'initial')};
  border-radius: ${({ isSponsored }) => (isSponsored ? '8px' : 'initial')};

  @media (--from-tablet) and (--only-mobile) {
    min-width: auto;
  }
`;
export const SeeMoreCaption: ElementType = styled.span<{ isSponsored: boolean }>`
  margin-top: var(--space-150) !important;

  & span[style='color:var(--text-primary)'][class*='typography'][class*='body_short'] {
    font-size: ${({ isSponsored }) => (isSponsored ? '15px !important' : 'inherit')};
  }
`;
